import { Link } from 'react-router-dom';
import ToggleDirections from '../../../../../common/ToggleDirections';

function MonitorStudentDirectionsSAT() {
  return (
    <ToggleDirections showDirectionInfo={true}>
      <div className='cb-white-bg'>
        <h3 className='tdtk-h3 how-to-Monitor-Testing'>How to Monitor Testing</h3>
        <div className='row px-0 mx-0 py-3 cb-border-top' role='region' aria-label='directions'>
          <div className='col-md-4 cb-margin-sm-down-bottom-16'>
            <h4 className='cb-paragraph6-st'>Reminders</h4>
            <ul className='pl-4 ml-2 mt-2'>
              <li>Walk around every 15 minutes.</li>
              <li>Make sure laptops are open and tablets are uncovered.</li>
              <li>Head coverings allowed for medical or religious reasons only.</li>
              <li>Students with hooded clothing must lower hoods during testing.</li>
              <li>Minimize distractions.</li>
            </ul>
          </div>
          <div className='col-md-4 cb-margin-sm-down-bottom-16'>
            <h4 className='cb-paragraph6-st'>Tips</h4>
            <ul className='pl-4 ml-2 mt-2'>
              <li>Offline devices can’t send updates, so some student statuses could be inaccurate.</li>
              <li>No action is required if students are testing smoothly.</li>
              <li>Send students to the help room if they have technical issues.</li>
              <li>
                <Link to='/irregularities'>Go to Irregularities to report all issues.</Link>
              </li>
            </ul>
          </div>
          <div className='col-md-4'>
            <h4 className='cb-paragraph6-st'>Digital Security Violations</h4>
            <ul className='pl-4 ml-2 mt-2'>
              <li>Viewing nontest content or using other applications.</li>
              <li>Trying to record or share test content in any way.</li>
              <li>Working on another student’s device.</li>
              <li>Angling a device so another student can see it.</li>
              <li>Alert your coordinator about security violations immediately.</li>
            </ul>
          </div>
        </div>
      </div>
    </ToggleDirections>
  );
}

export default MonitorStudentDirectionsSAT;
